<template>
  <el-dialog
    v-if="crossRateInModal"
    :title="crossRateInModal._id ? 'Редактировать курс' : 'Добавить курс'"
    :visible.sync="computedDialogVisible"
    :before-close="CancelEditCrossRateWithConfirm"
    custom-class="cross-rate-dialog"
  >
    <el-form
      @submit.prevent="SubmitCrossRate()"
      ref="crossRateInModal"
      :model="crossRateInModal"
      label-width="220px"
      v-loading="isLoading"
    >
      <el-form-item
        label="From (мы покупаем)"
        prop="from._id"
        :rules="validation.from.rules"
      >
        <el-select
          class="bottom-space"
          placeholder="From"
          clearable
          filterable
          required
          v-model="crossRateInModal.from._id"
        >
          <el-option
            v-for="item in valutes"
            :key="item._id"
            :label="item.title + ' - ' + item.key"
            :value="item._id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="To (мы продаем)"
        prop="to._id"
        :rules="validation.to.rules"
      >
        <el-select
          class="bottom-space"
          placeholder="To"
          clearable
          filterable
          required
          v-model="crossRateInModal.to._id"
        >
          <el-option
            v-for="item in valutes"
            :key="item._id"
            :label="item.title + ' - ' + item.key"
            :value="item._id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Город">
        <el-select
          class="bottom-space"
          placeholder="Город"
          clearable
          filterable
          v-model="crossRateInModal.city._id"
        >
          <el-option
            v-for="item in valuteCities"
            :key="item._id"
            :label="item.name"
            :value="item._id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="Курс"
        prop="out"
        :rules="crossRateInModal.makeTopIsActive ? [] : validation.out.rules"
      >
        <el-input
          type="number"
          min="0"
          step="any"
          placeholder="Курс"
          v-model="crossRateInModal.out"
          :required="!crossRateInModal.makeTopIsActive"
          :disabled="crossRateInModal.makeTopIsActive"
          :suffix-icon="loading ? 'el-icon-loading' : ''"
        ></el-input>
      </el-form-item>

      <el-alert
        title="info alert"
        :type="
          fromReference && toReference && crossRateInModal.out !== 'undefined'
            ? 'info'
            : 'warning'
        "
        show-icon
        :closable="false"
      >
        <template slot="title">
          Подсказка
        </template>
        <div
          v-if="
            fromReference && toReference && crossRateInModal.out !== 'undefined'
          "
        >
          <div>
            Нам присылают 1
            {{ fromReference ? fromReference.bestchangeKey : "..." }}, мы
            отправляем
            {{
              crossRateInModal.out
                ? parseFloat(crossRateInModal.out).toFixed(12)
                : "..."
            }}
            {{ toReference ? toReference.bestchangeKey : "..." }}
          </div>
          <div>
            Нам присылают
            {{
              crossRateInModal.out
                ? (
                    1 / parseFloat(parseFloat(crossRateInModal.out).toFixed(12))
                  ).toFixed(12)
                : "..."
            }}
            {{ fromReference ? fromReference.bestchangeKey : "..." }}, мы
            отправляем 1
            {{ toReference ? toReference.bestchangeKey : "..." }}
          </div>
        </div>
        <div v-else>
          <div>
            Выберите валюты и введите курс для отображения подсказки
          </div>
        </div>
      </el-alert>

      <el-alert
        v-if="
          (fromReference && fromReference.isCash) ||
            (toReference && toReference.isCash)
        "
        :type="'warning'"
        show-icon
        :closable="false"
      >
        <template slot="title">
          Внимание!
        </template>
        <div>
          В качестве одной из валют выбрана наличка.
        </div>
        <div>
          Итоговые лимиты будут учитывать дополнительную комиссию за доставку!
        </div>
        <div v-if="cityReference">
          Множитель за доставку в городе
          {{ cityReference.name }} составляет
          {{ cityReference.courierCommissionPercent }}
        </div>
        <div v-else>
          Город не выбран, множители за доставку будут взяты из справочника
          Города
        </div>
      </el-alert>
      <el-form-item label="Отключить направление">
        <el-switch v-model="crossRateInModal.isDisabled"></el-switch>
      </el-form-item>
      <el-form-item label="Индивидуальный курс">
        <el-switch v-model="crossRateInModal.isActive"></el-switch>
      </el-form-item>
      <el-form-item label="Выводить в топ Bestchange">
        <el-switch v-model="crossRateInModal.makeTopIsActive"></el-switch>
      </el-form-item>
      <el-form-item>
        <el-button
          size="medium"
          @click="handleSetDefaultMakeTopLimitPercent()"
          v-if="crossRateInModal.makeTopIsActive"
        >
          Установить лимит из валют
        </el-button>
      </el-form-item>
      <el-form-item
        :label="`Лимитный коэффициент`"
        prop="makeTopLimitMult"
        v-if="crossRateInModal.makeTopIsActive"
      >
        <el-input-number
          v-model="crossRateInModal.makeTopLimitMult"
          :min="0"
          :max="3"
          :step="0.001"
        ></el-input-number>
      </el-form-item>
      <div v-if="crossRateInModal.makeTopIsActive">
        <el-alert
          title="info alert"
          :type="
            fromReference && toReference && crossRateInModal.makeTopLimitMult
              ? 'info'
              : 'warning'
          "
          show-icon
          :closable="false"
        >
          <template slot="title">
            Подсказка
          </template>
          <div
            v-if="
              fromReference && toReference && crossRateInModal.makeTopLimitMult
            "
          >
            <div
              v-if="
                (fromReference && fromReference.isCash) ||
                  (toReference && toReference.isCash)
              "
            >
              <div>
                Используя текущие курсы и с учетом множителя доставки, получатся
                следующие лимиты:
              </div>
              <div v-if="cityReference">
                <div>
                  Не дороже
                  {{
                    fromReference.course &&
                    toReference.course &&
                    crossRateInModal.makeTopLimitMult
                      ? (
                          parseFloat(fromReference.course) /
                          (parseFloat(toReference.course) *
                            parseFloat(crossRateInModal.makeTopLimitMult) *
                            cityReference.courierCommissionPercent)
                        ).toFixed(12)
                      : "..."
                  }}
                  {{ toReference.bestchangeKey }} за 1
                  {{ fromReference.bestchangeKey }}
                </div>
                <div>
                  Не дешевле
                  {{
                    (
                      1 /
                      (parseFloat(fromReference.course) /
                        (parseFloat(toReference.course) *
                          parseFloat(crossRateInModal.makeTopLimitMult) *
                          cityReference.courierCommissionPercent))
                    ).toFixed(12)
                  }}
                  {{ fromReference.bestchangeKey }} за 1
                  {{ toReference.bestchangeKey }}
                </div>
              </div>
              <div v-else>
                Город не выбран, лимиты будут пересчитаны согласно множителям из
                справочника Города
              </div>
            </div>
            <div v-else>
              <div>Используя текущие курсы, получатся следующие лимиты:</div>
              <div>
                Не дороже
                {{
                  fromReference.course &&
                  toReference.course &&
                  crossRateInModal.makeTopLimitMult
                    ? (
                        parseFloat(fromReference.course) /
                        (parseFloat(toReference.course) *
                          parseFloat(crossRateInModal.makeTopLimitMult))
                      ).toFixed(12)
                    : "..."
                }}
                {{ toReference.bestchangeKey }} за 1
                {{ fromReference.bestchangeKey }}
              </div>
              <div>
                Не дешевле
                {{
                  (
                    1 /
                    (parseFloat(fromReference.course) /
                      (parseFloat(toReference.course) *
                        parseFloat(crossRateInModal.makeTopLimitMult)))
                  ).toFixed(12)
                }}
                {{ fromReference.bestchangeKey }} за 1
                {{ toReference.bestchangeKey }}
              </div>
            </div>
          </div>
          <div v-else>
            Выберите валюты и заполните лимиты для получения подсказки
          </div>
        </el-alert>
      </div>
      <el-form-item
        label="Отступ"
        prop="makeTopStep"
        v-if="crossRateInModal.makeTopIsActive"
      >
        <el-input
          type="number"
          min="0"
          step="any"
          placeholder="Отступ"
          v-model="crossRateInModal.makeTopStep"
          :required="crossRateInModal.makeTopIsActive"
        >
          <template slot="append">{{
            toReference && toReference.bestchangeKey
              ? toReference.bestchangeKey
              : ""
          }}</template>
        </el-input>
      </el-form-item>
      <div v-if="crossRateInModal.makeTopIsActive">
        <el-alert
          title="info alert"
          :type="
            fromReference &&
            toReference &&
            crossRateInModal.out !== 'undefined' &&
            crossRateInModal.makeTopStep
              ? 'info'
              : 'warning'
          "
          show-icon
          :closable="false"
        >
          <template slot="title">
            Подсказка
          </template>
          <div
            v-if="
              fromReference &&
                toReference &&
                crossRateInModal.out !== 'undefined' &&
                crossRateInModal.makeTopStep
            "
          >
            <div>
              Если у конкурента курс
              {{ parseFloat(crossRateInModal.out).toFixed(12) }}
              {{ toReference ? toReference.bestchangeKey : "..." }} за 1
              {{ fromReference ? fromReference.bestchangeKey : "..." }}, то мы
              выставим курс
              {{
                parseFloat(
                  parseFloat(crossRateInModal.out) +
                    parseFloat(crossRateInModal.makeTopStep)
                ).toFixed(12)
              }}
              {{ toReference ? toReference.bestchangeKey : "..." }} за 1
              {{ fromReference ? fromReference.bestchangeKey : "..." }}:
            </div>
            <div>
              И станет:
            </div>
            <div>
              Нам присылают 1
              {{ fromReference ? fromReference.bestchangeKey : "..." }}, мы
              отправляем
              {{
                crossRateInModal.out
                  ? parseFloat(
                      parseFloat(crossRateInModal.out) +
                        parseFloat(crossRateInModal.makeTopStep)
                    ).toFixed(12)
                  : "..."
              }}
              {{ toReference ? toReference.bestchangeKey : "..." }}
            </div>
            <div>
              Нам присылают
              {{
                crossRateInModal.out
                  ? (
                      1 /
                      parseFloat(
                        parseFloat(
                          parseFloat(crossRateInModal.out) +
                            parseFloat(crossRateInModal.makeTopStep)
                        ).toFixed(12)
                      )
                    ).toFixed(12)
                  : "..."
              }}
              {{ fromReference ? fromReference.bestchangeKey : "..." }}, мы
              отправляем 1
              {{ toReference ? toReference.bestchangeKey : "..." }}
            </div>
          </div>
          <div v-else>
            Выберите валюты, заполните курс и введите отступ для получения
            подсказки
          </div>
        </el-alert>
      </div>
      <el-form-item
        label="Не конкуренты"
        prop="makeTopIgnoredExchangeNames"
        v-if="crossRateInModal.makeTopIsActive"
      >
        <el-select
          class="bottom-space"
          placeholder="Не конкуренты"
          clearable
          filterable
          multiple
          v-model="crossRateInModal.makeTopIgnoredExchangeNames"
        >
          <el-option
            v-for="item in sourceProjects.docs.filter(o => o.option === true)"
            :key="item.bestchangeName"
            :label="item.name"
            :value="item.bestchangeName"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-popconfirm
        title="Прекратить редактирование?"
        @confirm="CancelEditCrossRate"
        :disabled="isLoading"
      >
        <el-button slot="reference">Отмена</el-button>
      </el-popconfirm>

      <el-popconfirm
        title="Сохранить изменения?"
        @confirm="SubmitCrossRate"
        :disabled="isLoading"
      >
        <el-button slot="reference" type="primary">Сохранить</el-button>
      </el-popconfirm>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import validation from "../../validation";
import { getProjects, getValuteCities } from "@/api";
//
export default {
  name: "EditCrossRateComponent",
  props: ["modal"],
  //
  data() {
    return {
      validation,
      sourceProjects: [],
      valuteCities: [],
      isLoading: true
    };
  },
  //
  computed: {
    ...mapState("auth", ["session"]),
    ...mapState("crossRate", [
      "valutes",
      "isFiltered",
      "crossRateInModal",
      "dialogVisible",
      "loading"
    ]),
    computedDialogVisible: {
      get() {
        return this.dialogVisible;
      },
      set(val) {
        this.changeDialogVisible({ dialogVisible: val });
      }
    },
    fromReference() {
      return this.valutes.find(v => v._id === this.crossRateInModal.from._id);
    },
    toReference() {
      return this.valutes.find(v => v._id === this.crossRateInModal.to._id);
    },
    cityReference() {
      return this.valuteCities.find(
        v => v._id === this.crossRateInModal.city._id
      );
    }
  },
  //
  methods: {
    ...mapActions("crossRate", [
      "addCrossRate",
      "editCrossRate",
      "changeDataInModal",
      "changeDialogVisible",
      "queryPaginationCrossRates"
    ]),

    CancelEditCrossRateWithConfirm() {
      this.$confirm("Прекратить редактирование?", "", {
        confirmButtonText: "Да",
        cancelButtonText: "Нет"
      })
        .then(_ => {
          this.CancelEditCrossRate();
        })
        .catch(_ => {});
    },

    CancelEditCrossRate() {
      this.changeDialogVisible({ dialogVisible: false });
      this.changeDataInModal({});

      if (typeof this.$refs["crossRateInModal"] !== "undefined") {
        this.$refs["crossRateInModal"].clearValidate();
        this.$refs["crossRateInModal"].resetFields();
      }
    },

    SubmitCrossRate() {
      this.$refs["crossRateInModal"].validate(async valid => {
        if (valid) {
          const crossRate = { ...this.crossRateInModal };
          if (!crossRate.city._id) {
            crossRate.city = null;
          }

          // let resp;
          //
          try {
            this.isLoading = true;
            if (crossRate._id) {
              await this.editCrossRate(crossRate);
            } else {
              await this.addCrossRate(crossRate);
            }
            this.$nextTick().then(() =>
              this.$message.success("Операция прошла успешно")
            );
            this.CancelEditCrossRate();
            await this.queryPaginationCrossRates();
          } catch (error) {
            this.$message({
              type: "error",
              message:
                error.response.data.message || "Ошибка! Изменения не сохранены."
            });
          } finally {
            this.isLoading = false;
          }
        } else {
          this.$message({
            type: "error",
            message: "Ошибка при заполнении формы!"
          });
        }
      });
    },

    handleSetDefaultMakeTopLimitPercent() {
      if (this.fromReference && this.toReference) {
        this.crossRateInModal.makeTopLimitMult = parseFloat(
          (
            this.fromReference.percentGet / this.toReference.percentGive
          ).toFixed(3)
        );
      }
    }
  },
  async mounted() {
    try {
      this.isLoading = true;
      const projects = await getProjects({
        limit: 1000,
        query: { $and: [{ option: true }, { bestchangeName: { $ne: null } }] }
      });

      if (projects.data.status) {
        this.sourceProjects = projects.data.result;
      }

      const valuteCities = await getValuteCities({
        limit: 1000,
        query: { isActive: true }
      });

      if (valuteCities.data.status) {
        this.valuteCities = valuteCities.data.result.docs;
      }
    } catch (error) {
      this.handleResponseError(error);
    } finally {
      this.isLoading = false;
    }
  }
};
</script>

<style scoped>
.el-dialog__wrapper >>> .cross-rate-dialog {
  width: 30%;
  min-width: 500px;
}

.long-label >>> .el-form-item__label {
  line-height: 1.5;
  word-break: break-word;
}

.delete {
  color: red;
  float: right;
}

.edit {
  color: orange;
  float: right;
  margin-right: 5px;
}

.delete,
.edit {
  cursor: pointer;
}

label,
.el-select {
  display: block;
}

.valute-forms input {
  display: block;
  max-width: 92%;
}

.content__label {
  margin-top: 15px;
  margin-bottom: 5px;
}

.input-error {
  font-size: 12px;
  color: #f22;
  margin-left: 200px;
  margin-top: -15px;
}

.text-center {
  text-align: center;
}

.hr {
  border-top: 1px solid #ebeef5;
  margin: 1em 0;
}

.box-card {
  margin-top: 30px;
}

.valute-forms-list {
  padding-left: 20px;
}

.valute-forms-list li {
  margin-bottom: 10px;
}

.valute-forms-list li:last-child {
  margin-bottom: 0;
}

.title-margin {
  margin-bottom: 1.5em;
  margin-top: 1.5em;
}

.computed {
  margin-left: 200px;
  margin-bottom: 20px;
}

.full-width-field {
  width: 100%;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/CrossRate/components/EditCrossRate/index.vue